export default __webpack_public_path__ + "static/media/LIQ.f72f345a.png";